import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import GameModel from "./model/GameModel";
import SoundManager from "Engine/soundManager/SoundManager";
import * as PIXI from "pixi.js";
import BaseSlotWinningsController from "Engine/slots/BaseSlotWinningsController";
import EntryPoint from "Engine/EntryPoint";

export default class Main extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.reelsContainer = null;
        this.linesContainer = null;
        this.winningContainer = null;

        this.init();
        this.addListeners();
    }

    init() {
        this.backgroundSoundName = 'sounds/mainGame/Background1';
        SoundManager.play(this.backgroundSoundName, 1, true, 'music');

        this.winningsController = new BaseSlotWinningsController();

        this.backgroundContainer = this.getChildByName('BackgroundContainer');
        this.decorationsContainer = this.getChildByName('DecorationsContainer');
        this.reelsContainer = this.getChildByName('ReelsContainer');
        this.symbolsAnimationsContainer = this.getChildByName('SymbolsAnimationsContainer');
        this.lineWinningContainer = this.getChildByName('LineWinningContainer');
        this.freeSpinsWindowContainer = this.getChildByName('FreeSpinsWindowContainer');
        //this.linesContainer = this.getChildByName('LinesContainer');
        this.bonusGameContainer = this.getChildByName('BonusGameContainer');
        this.bigWinContainer = this.getChildByName('BigWinContainer');
        this.wildsContainer = this.getChildByName('WildsContainer');

        //this.linesContainer.showLines(GameModel.lines);
    }

    addListeners() {
        GlobalDispatcher.add('model:linesChanged', this.onLinesChanged, this);
        GlobalDispatcher.add('stateManager.stateChanged', this.onStateChanged, this);
        GlobalDispatcher.add('scaleManager:resize', (event) => {
            if (EntryPoint.mobile) {
                this.y = event.params.canvasWidth > event.params.canvasHeight ? 0 : 200;
            }
        });
        GlobalDispatcher.addOnce('stateEnd:splashScreenState', this.onEndSplashScreenState, this);
        this.once('added', ()=>{
            this.onEndSplashScreenState();
        });
    }

    onEndSplashScreenState() {
        this.visible = true;

        if (EntryPoint.GameModel.isFreeSpins) {
            this.reelsContainer.changeState(2);
            this.symbolsAnimationsContainer.changeState(2);
            this.wildsContainer.changeState(2);
            this.backgroundContainer = this.parent.getChildByName('BackgroundContainer');
            this.backgroundContainer.changeState(2);
            this.decorationsContainer.changeState(2);

            SoundManager.stop(this.backgroundSoundName);
            this.backgroundSoundName = 'sounds/mainGame/BackgroundFreeSpins';
            SoundManager.play(this.backgroundSoundName, 1, true, 'music');
        }
    }

    onLinesChanged(data) {
        //this.linesContainer.showLines(data.params);
    }

    onStateChanged(data) {
        switch (data.params) {
            case 'initState':

                break;
            case 'splashScreenState':
                this.visible = false;
                break;
            case 'idleState':
                /*this.reelsContainer.hideWinningSymbols();
                this.linesContainer.hideLines();
                this.linesContainer.reset();*/
                this.freeSpinsWindowContainer.hide();
                break;
            case 'requestRollingState':
                this.reelsContainer.hideWinningSymbols();
                this.reelsContainer.start();
                this.winningsController.reset();
                /*this.linesContainer.hideLines();
                this.linesContainer.reset();*/
                this.symbolsAnimationsContainer.removeAnimations();
                this.lineWinningContainer.hide();
                this.reelsContainer.setActive(true);
                break;
            case 'stopRollingState':
                EntryPoint.NearWinCalculator.calculate();
                this.reelsContainer.stop(GameModel.reels);
                break;
            case 'showBigWinState':
                SoundManager.pause(this.backgroundSoundName);
                break;
            case 'showWinningsState':
                SoundManager.resume(this.backgroundSoundName);
                this.winningsController.start();
                this.lineWinningContainer.show();
                this.reelsContainer.setActive(false);
                //this.linesContainer.showWinLines(GameModel.winnings.lines);
                break;
            case 'freeSpinsInState':
                this.reelsContainer.changeState(2);
                this.symbolsAnimationsContainer.changeState(2);
                this.wildsContainer.changeState(2);
                this.freeSpinsWindowContainer.show(1);
                this.backgroundContainer = this.parent.getChildByName('BackgroundContainer');
                this.backgroundContainer.changeState(2);
                this.decorationsContainer.changeState(2);
                this.reelsContainer.hideWinningSymbols();
                this.winningsController.reset();
                this.symbolsAnimationsContainer.removeAnimations();
                this.lineWinningContainer.hide();
                this.reelsContainer.setActive(true);
                EntryPoint.AutoPlaySettings.paused = true;

                //EntryPoint.AutoPlaySettings.selectedCount = 99999;
                //EntryPoint.AutoPlaySettings.active = true;

                SoundManager.stop(this.backgroundSoundName);
                this.backgroundSoundName = 'sounds/mainGame/BackgroundFreeSpins';
                SoundManager.play(this.backgroundSoundName, 1, true, 'music');
                break;
            case 'freeSpinsOutState':
                this.reelsContainer.changeState(1);
                this.symbolsAnimationsContainer.changeState(1);
                this.wildsContainer.changeState(1);
                this.freeSpinsWindowContainer.show(2);
                this.backgroundContainer = this.parent.getChildByName('BackgroundContainer');
                this.backgroundContainer.changeState(1);
                this.decorationsContainer.changeState(1);
                this.reelsContainer.hideWinningSymbols();
                this.winningsController.reset();
                this.symbolsAnimationsContainer.removeAnimations();
                this.lineWinningContainer.hide();
                this.reelsContainer.setActive(true);

                EntryPoint.AutoPlaySettings.paused = false;
                //EntryPoint.AutoPlaySettings.active = false;
                //EntryPoint.AutoPlaySettings.resetCount();

                SoundManager.stop(this.backgroundSoundName);
                this.backgroundSoundName = 'sounds/mainGame/Background1';
                SoundManager.play(this.backgroundSoundName, 1, true, 'music');
                break;
            /*case 'showBigWinState':
                this.bigWinContainer.show();
                this.bonusGameContainer.hide();
                break;*/
        }
    }
}
